"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e["default"] : e,
    r = require("theme-ui"),
    o = require("@emotion/core");

function i() {
  return (i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function a(e) {
  return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function s(e, t) {
  return (s = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function c() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function l(e, t, n) {
  return (l = c() ? Reflect.construct : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var o = new (Function.bind.apply(e, r))();
    return n && s(o, n.prototype), o;
  }).apply(null, arguments);
}

function u(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (u = function u(e) {
    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }

    function n() {
      return l(e, arguments, a(this).constructor);
    }

    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), s(n, e);
  })(e);
}

function f() {
  if ("undefined" == typeof window) throw new Error("Session ID cannot be generated server-side!");
  var e = window.localStorage.getItem("sessionId");
  if (e) return e;
  var t = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  return window.localStorage.setItem("sessionId", t), t;
}

function m(e, t) {
  try {
    var n = e();
  } catch (e) {
    return t(e);
  }

  return n && n.then ? n.then(void 0, t) : n;
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

var d = function (e) {
  var t, n;

  function r(t, n, r) {
    var o;
    return (o = e.call(this, "Failed API request to " + t + " with status " + r.status) || this).requestInfo = t, o.requestInit = n, o.response = r, o;
  }

  return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, r;
}(u(Error)),
    p = function () {
  function e(e) {
    this.client = e;
  }

  var t = e.prototype;
  return t.press = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.put(n ? "/like-buttons/" + n + "/" + t + "/press" : "/like-buttons/" + t + "/press", "press");
  }, t.info = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.get(n ? "/like-buttons/" + n + "/" + t : "/like-buttons/" + t);
  }, e;
}(),
    h = function () {
  function e(e) {
    this.client = e;
  }

  var t = e.prototype;
  return t.press = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.put(n ? "/clap-buttons/" + n + "/" + t + "/press" : "/clap-buttons/" + t + "/press", "press");
  }, t.info = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.get(n ? "/clap-buttons/" + n + "/" + t : "/clap-buttons/" + t);
  }, e;
}(),
    v = function () {
  function e(e) {
    this.client = e;
  }

  var t = e.prototype;
  return t.info = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.get(n ? "/updown-buttons/" + n + "/" + t : "/updown-buttons/" + t);
  }, t.pressUp = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.put(n ? "/updown-buttons/" + n + "/" + t + "/press-up" : "/updown-buttons/" + t + "/press-up", "press-up");
  }, t.pressDown = function (e) {
    var t = e.id,
        n = e.namespace;
    return this.client.put(n ? "/updown-buttons/" + n + "/" + t + "/press-down" : "/updown-buttons/" + t + "/press-down", "press-down");
  }, e;
}(),
    b = function () {
  function e(e) {
    var t = e.recaptchaSiteKey,
        n = e.baseUrl;
    this.apiKey = e.apiKey, this.recaptchaSiteKey = t, this.baseUrl = n || "https://lyket.herokuapp.com", this.likeButtons = new p(this), this.clapButtons = new h(this), this.updownButtons = new v(this);
  }

  var t = e.prototype;
  return t.get = function (e) {
    return this.request(e);
  }, t.put = function (e, t) {
    return this.request(e, {
      method: "PUT",
      recaptchaAction: t
    });
  }, t.request = function (e, t) {
    try {
      var n = function n() {
        var n = r.baseUrl + "/v1" + e,
            a = t ? i({}, t, {
          headers: i({}, o, t.headers),
          body: t.body && JSON.stringify(t.body)
        }) : {
          headers: o
        };
        return Promise.resolve(fetch(n, a)).then(function (e) {
          if (e.status < 200 || e.status >= 300) throw new d(n, a, e);
          return e.json();
        });
      },
          r = this;

      if ("undefined" == typeof window) throw "Client is supposed to be used client-side only!";

      var o = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + r.apiKey,
        "x-session-id": f()
      },
          a = function () {
        if (r.recaptchaSiteKey && t && t.recaptchaAction) return Promise.resolve((e = r.recaptchaSiteKey, n = t.recaptchaAction, (i = "https://www.google.com/recaptcha/api.js?render=" + e, void 0 === a && (a = {}), new Promise(function (e, t) {
          var n = a.async,
              r = a.integrity,
              o = a.type,
              s = document.querySelector('script[src="' + i + '"]');
          if (s) e(s);else {
            var c = document.createElement("script");
            c.src = i, n && c.setAttribute("async", "true"), r && c.setAttribute("integrity", r), o && c.setAttribute("type", o), c.onload = function () {
              return e(c);
            }, c.onerror = function (e) {
              return t(e);
            }, document.body.appendChild(c);
          }
        })).then(function () {
          return new Promise(function (t, r) {
            grecaptcha.ready(function () {
              try {
                var o = m(function () {
                  return Promise.resolve(grecaptcha.execute(e, {
                    action: n
                  })).then(function (e) {
                    t(e);
                  });
                }, function (e) {
                  console.log("recaptcha error!", e), r(e);
                });
                return Promise.resolve(o && o.then ? o.then(function () {}) : void 0);
              } catch (e) {
                return Promise.reject(e);
              }
            });
          });
        }))).then(function (e) {
          o["x-recaptcha-token"] = e;
        });
        var e, n, i, a;
      }();

      return Promise.resolve(a && a.then ? a.then(n) : n());
    } catch (e) {
      return Promise.reject(e);
    }
  }, e;
}(),
    y = n.createContext(null),
    g = {
  fonts: {
    body: "system-ui, sans-serif",
    heading: '"Avenir Next", sans-serif',
    monospace: "Menlo, monospace"
  },
  colors: {
    text: "#000",
    background: "#fff",
    primary: "#33e"
  }
},
    x = function x(e, n) {
  var r = t.useState()[1];
  return t.useEffect(function () {
    !function () {
      try {
        var t = m(function () {
          return Promise.resolve(e()).then(function () {});
        }, function (e) {
          r(function () {
            throw e;
          });
        });
        Promise.resolve(t && t.then ? t.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    }();
  }, n);
},
    k = function k(e) {
  return n.createElement("svg", {
    viewBox: "0 0 128 128",
    className: e.className
  }, n.createElement("path", {
    d: "M51.78,85.86c-0.96,0.92-1.94-0.15-1.94-0.15S33.37,68.67,32.31,67.92c-1.5-1.07-4.7-2.73-7.85,0.59 c-1.31,1.38-3.45,4.44,0.64,9.28c0.88,1.04,26.53,27.44,28.02,28.86c0,0,11.84,11.25,18.96,15.45c1.98,1.17,4.2,2.4,6.79,3.25 c2.58,0.85,5.49,1.42,8.55,1.39c3.06,0,6.23-0.63,9.22-1.76c2.99-1.14,5.77-2.79,8.29-4.68c0.62-0.48,1.24-0.97,1.83-1.48 l1.69-1.43c1.18-1.01,2.27-2.06,3.32-3.15c2.11-2.16,4.01-4.45,5.68-6.8c1.66-2.36,3.07-4.8,4.18-7.22 c1.11-2.42,1.89-4.85,2.34-7.15c0.48-2.29,0.6-4.45,0.5-6.32c-0.04-1.88-0.43-3.49-0.76-4.77c-0.37-1.28-0.75-2.24-1.06-2.87 c-0.3-0.63-0.46-0.97-0.46-0.97l0,0c-0.42-1.13-0.81-2.21-1.18-3.18c-1-2.74-2.15-5.82-3.35-8.98c-0.51-1.34-0.74-1.95-0.74-1.95 l0.01,0.02c-4.4-11.53-9.13-23.42-9.13-23.42c-0.72-2.09-3.28-2.8-5.16-1.42c-5.39,3.97-6.99,9.69-5,15.75l5.08,13.42 c0.71,1.5-1.18,3.26-2.48,2.23c-4.08-3.24-12.73-12.21-12.73-12.21c-3.86-3.62-25.66-25.45-27.13-26.78 c-2.93-2.67-6.61-4.02-9.38-1.93c-2.82,2.12-3.58,5.37-0.79,8.87c0.76,0.95,22.8,23.7,22.8,23.7c1.29,1.32-0.19,3.21-1.6,1.94 c0,0-27.42-27.94-28.66-29.25c-2.81-2.97-7.27-3.58-9.88-1.08c-2.55,2.45-2.44,6.42,0.41,9.5c0.91,0.98,20.22,20.9,27.96,29.06 c0.52,0.55,0.92,1.28,0.18,1.99c-0.01,0.01-0.76,0.85-1.76-0.2c-2.1-2.19-23.09-23.55-24.26-24.71c-2.68-2.65-6.25-3.88-9.07-1.23 c-2.58,2.42-2.95,6.58,0.08,9.49l25.43,26.26C51.86,84.04,52.68,85,51.78,85.86z",
    style: {
      fill: "#FAC036"
    }
  }), n.createElement("path", {
    d: "M42.37,79.54c-0.52,1.22-1.85,0.61-1.85,0.61s-21.8-9.29-23.07-9.57c-1.8-0.4-5.39-0.68-7,3.6 c-0.67,1.78-1.45,5.43,4.2,8.3c1.22,0.62,35.11,14.95,37.04,15.69c0,0,15.28,5.76,23.48,6.85c2.28,0.3,4.81,0.58,7.52,0.35 c2.71-0.22,5.61-0.82,8.41-2.05c2.82-1.19,5.49-3.01,7.8-5.21c2.31-2.21,4.23-4.81,5.81-7.53c0.39-0.68,0.77-1.37,1.11-2.07 l1.01-1.97c0.69-1.39,1.29-2.79,1.84-4.19c1.11-2.81,1.96-5.66,2.59-8.48c0.61-2.82,0.96-5.61,1.04-8.28 c0.08-2.67-0.15-5.21-0.62-7.5c-0.44-2.3-1.18-4.33-2-6.02c-0.77-1.72-1.76-3.04-2.55-4.1c-0.84-1.03-1.56-1.77-2.09-2.23 c-0.52-0.46-0.8-0.71-0.8-0.71l0,0c-0.82-0.88-1.61-1.72-2.32-2.47c-1.99-2.14-4.25-4.52-6.58-6.96c-0.99-1.04-1.44-1.5-1.44-1.5 l0.02,0.02C85.37,25.21,76.39,16.1,76.39,16.1c-1.47-1.65-4.11-1.3-5.3,0.7c-3.42,5.76-2.67,11.64,1.52,16.45l9.9,10.39 c1.24,1.1,0.18,3.46-1.42,3.02c-5.02-1.4-16.47-6.3-16.47-6.3C59.65,38.53,31.07,26.9,29.2,26.24c-3.74-1.32-7.65-1.13-9.39,1.87 c-1.77,3.05-1.21,6.34,2.73,8.48c1.07,0.58,30.22,12.96,30.22,12.96c1.7,0.71,1.07,3.03-0.72,2.41c0,0-36.13-15.07-37.78-15.8 c-3.74-1.65-8.09-0.47-9.52,2.85C3.35,42.26,5,45.88,8.82,47.6c1.21,0.55,26.76,11.39,37.06,15.89c0.69,0.3,1.34,0.82,0.94,1.77 c0,0.01-0.37,1.08-1.7,0.5c-2.79-1.2-30.43-12.72-31.96-13.33c-3.5-1.4-7.26-1.14-8.84,2.39c-1.44,3.23-0.16,7.21,3.76,8.71 l33.64,14.3C41.72,77.83,42.86,78.4,42.37,79.54z",
    style: {
      fill: "#FAC036"
    }
  }), n.createElement("path", {
    d: "M101.45,64.4c1.13,2.62,2.93,4.52,0.24,6.47c-3.66,2.65-11.15-6.43-14.15-9.48 c-3.73-3.81-7.36-7.84-11.16-11.6c-5.17-5.13-12.26-12.09-17.31-17.36c-5.85-6.1-11.7,1.18-8.93,6.84 c0.26,0.56,0.64,1.11,1.13,1.69c1.5,1.71,3.12,3.3,4.71,4.93c0.02,0.02,12.45,11.92,16.52,16.03c1.85,1.92,0.85,4.29-0.33,3.22 s-9.16-8.2-12.78-11.89c-5.69-5.8-12.95-13.04-19.45-18.45c-3.68-3.07-12.33,3.15-4.17,11.16c0.31,0.31,24.38,23.9,27.43,26.91 c0.99,0.97-0.6,1.99-0.6,1.99c-0.66,0.58-26.59-24.01-27.56-24.98c-5.31-5.33-14.45,1.26-6.97,8.89 c2.73,2.78,11.38,11.67,17,17.48c1.86,1.93,6.43,6.07,9.17,8.46c0.57,0.5-0.83,1.09-1.17,1.55c-0.5,0.69-19.11-16.16-21.03-17.7 c-4.27-3.42-11.67,2.6-7.33,8.39c2.23,2.97,17.73,17.63,19.97,19.76c11.63,11.05,13.86,13.79,28.01,23.8 c1.8,1.28,6.93,5.24,5.42,4.6c-19.87-8.52-37.36-28.24-52.48-42.02c-4.42-4.03-7.82-11.53-2.59-16.53 c2.06-1.96,3.47-2.38,6.14-2.22c0,0-0.16-0.19-2.49-2.67c-2.25-2.39-7.43-9.59-2.62-14.24c3.78-3.66,8.01-2.06,7.69-2.42 c-3.59-4.29-3.15-9.04-0.09-11.91c3.68-3.46,8.68-3.61,15.17,3.09c-0.4-1.2-1.33-4.16,1.77-6.97c6-5.46,11.08-1.54,22.51,10.76 C80.62,50.17,95.35,65.2,95.35,65.2c0.84,0.75,3.03,3.38,4.4,2.55c0.8-0.49-0.46-1.96-1.78-4.98c-4.74-10.81-4.84-20.2,5.75-24.07 c0.68-0.63-4.02,3.49-5.44,8.13C96.91,51.29,98.85,58.35,101.45,64.4z",
    style: {
      fill: "#E48C15"
    }
  }), n.createElement("line", {
    style: {
      fill: "none",
      stroke: "#444444",
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: "101.28",
    x2: "94.87",
    y1: "3.12",
    y2: "23.23"
  }), n.createElement("line", {
    style: {
      fill: "none",
      stroke: "#444444",
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: "42.49",
    x2: "31.79",
    y1: "22.7",
    y2: "9.97"
  }), n.createElement("line", {
    style: {
      fill: "none",
      stroke: "#444444",
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: "52.79",
    x2: "50.42",
    y1: "3.12",
    y2: "21.68"
  }), n.createElement("line", {
    style: {
      fill: "none",
      stroke: "#444444",
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: "112.7",
    x2: "100.35",
    y1: "21.36",
    y2: "31.28"
  }));
},
    w = {
  root: {
    color: "inherit",
    fontFamily: "inherit",
    display: "inline-flex",
    alignItems: "center",
    fontSize: "inherit"
  },
  counter: {
    marginLeft: "1em"
  },
  icon: {
    height: "3em"
  },
  button: {
    border: "none",
    outline: "none",
    cursor: "pointer",
    background: "transparent",
    appearance: "none",
    position: "relative",
    fontSize: "inherit",
    p: 0,
    "@media (hover: hover)": {
      ":hover": {
        svg: {
          transition: "all 0.2s ease-in-out",
          transform: "scale(1.1)"
        },
        div: {
          opacity: 1
        }
      }
    }
  },
  amount: {
    opacity: 0,
    fontSize: ".8em",
    height: "2em",
    width: "2em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "-1em",
    right: "-1em",
    backgroundColor: "#E5214A",
    color: "white",
    borderRadius: "100%",
    transition: "all 0.2s ease-in-out"
  }
},
    j = function j(e) {
  var t = e.userClaps,
      n = e.totalClaps,
      o = e.onClick,
      i = e.isCounterVisible;
  return e.isLoading ? r.jsx("span", null, "Loading...") : r.jsx("div", {
    sx: w.root
  }, r.jsx("button", {
    onClick: o,
    sx: w.button
  }, r.jsx(k, {
    sx: w.icon
  }), r.jsx("div", {
    sx: w.amount
  }, t)), i && r.jsx("span", {
    sx: w.counter
  }, n));
},
    C = function C(e) {
  return n.createElement("svg", {
    viewBox: "0 0 33 33",
    "aria-label": "clap",
    className: e.className
  }, n.createElement("path", {
    d: "M28.86 17.34l-3.64-6.4c-.3-.43-.71-.73-1.16-.8a1.12 1.12 0 0 0-.9.21c-.62.5-.73 1.18-.32 2.06l1.22 2.6 1.4 2.45c2.23 4.09 1.51 8-2.15 11.66a9.6 9.6 0 0 1-.8.71 6.53 6.53 0 0 0 4.3-2.1c3.82-3.82 3.57-7.87 2.05-10.39zm-6.25 11.08c3.35-3.35 4-6.78 1.98-10.47L21.2 12c-.3-.43-.71-.72-1.16-.8a1.12 1.12 0 0 0-.9.22c-.62.49-.74 1.18-.32 2.06l1.72 3.63a.5.5 0 0 1-.81.57l-8.91-8.9a1.33 1.33 0 0 0-1.89 1.88l5.3 5.3a.5.5 0 0 1-.71.7l-5.3-5.3-1.49-1.49c-.5-.5-1.38-.5-1.88 0a1.34 1.34 0 0 0 0 1.89l1.49 1.5 5.3 5.28a.5.5 0 0 1-.36.86.5.5 0 0 1-.36-.15l-5.29-5.29a1.34 1.34 0 0 0-1.88 0 1.34 1.34 0 0 0 0 1.89l2.23 2.23L9.3 21.4a.5.5 0 0 1-.36.85.5.5 0 0 1-.35-.14l-3.32-3.33a1.33 1.33 0 0 0-1.89 0 1.32 1.32 0 0 0-.39.95c0 .35.14.69.4.94l6.39 6.4c3.53 3.53 8.86 5.3 12.82 1.35zM12.73 9.26l5.68 5.68-.49-1.04c-.52-1.1-.43-2.13.22-2.89l-3.3-3.3a1.34 1.34 0 0 0-1.88 0 1.33 1.33 0 0 0-.4.94c0 .22.07.42.17.61zm14.79 19.18a7.46 7.46 0 0 1-6.41 2.31 7.92 7.92 0 0 1-3.67.9c-3.05 0-6.12-1.63-8.36-3.88l-6.4-6.4A2.31 2.31 0 0 1 2 19.72a2.33 2.33 0 0 1 1.92-2.3l-.87-.87a2.34 2.34 0 0 1 0-3.3 2.33 2.33 0 0 1 1.24-.64l-.14-.14a2.34 2.34 0 0 1 0-3.3 2.39 2.39 0 0 1 3.3 0l.14.14a2.33 2.33 0 0 1 3.95-1.24l.09.09c.09-.42.29-.83.62-1.16a2.34 2.34 0 0 1 3.3 0l3.38 3.39a2.17 2.17 0 0 1 1.27-.17c.54.08 1.03.35 1.45.76.1-.55.41-1.03.9-1.42a2.12 2.12 0 0 1 1.67-.4 2.8 2.8 0 0 1 1.85 1.25l3.65 6.43c1.7 2.83 2.03 7.37-2.2 11.6zM13.22.48l-1.92.89 2.37 2.83-.45-3.72zm8.48.88L19.78.5l-.44 3.7 2.36-2.84zM16.5 3.3L15.48 0h2.04L16.5 3.3z",
    "fill-rule": "evenodd"
  }));
},
    L = function L(e) {
  return n.createElement("svg", {
    viewBox: "0 0 29 29",
    "aria-label": "clap",
    className: e.className
  }, n.createElement("path", {
    d: "M13.74 1l.76 2.97.76-2.97zM18.63 2.22l-1.43-.47-.4 3.03zM11.79 1.75l-1.43.47 1.84 2.56zM24.47 14.3L21.45 9c-.29-.43-.69-.7-1.12-.78a1.16 1.16 0 0 0-.91.22c-.3.23-.48.52-.54.84l.05.07 2.85 5c1.95 3.56 1.32 6.97-1.85 10.14a8.46 8.46 0 0 1-.55.5 5.75 5.75 0 0 0 3.36-1.76c3.26-3.27 3.04-6.75 1.73-8.91M14.58 10.89c-.16-.83.1-1.57.7-2.15l-2.5-2.49c-.5-.5-1.38-.5-1.88 0-.18.18-.27.4-.33.63l4.01 4z"
  }), n.createElement("path", {
    d: "M17.81 10.04a1.37 1.37 0 0 0-.88-.6.81.81 0 0 0-.64.15c-.18.13-.71.55-.24 1.56l1.43 3.03a.54.54 0 1 1-.87.61L9.2 7.38a.99.99 0 1 0-1.4 1.4l4.4 4.4a.54.54 0 1 1-.76.76l-4.4-4.4L5.8 8.3a.99.99 0 0 0-1.4 0 .98.98 0 0 0 0 1.39l1.25 1.24 4.4 4.4a.54.54 0 0 1 0 .76.54.54 0 0 1-.76 0l-4.4-4.4a1 1 0 0 0-1.4 0 .98.98 0 0 0 0 1.4l1.86 1.85 2.76 2.77a.54.54 0 0 1-.76.76L4.58 15.7a.98.98 0 0 0-1.4 0 .99.99 0 0 0 0 1.4l5.33 5.32c3.37 3.37 6.64 4.98 10.49 1.12 2.74-2.74 3.27-5.54 1.62-8.56l-2.8-4.94z"
  }));
},
    P = {
  root: {
    color: "inherit",
    fontFamily: "inherit",
    display: "inline-flex",
    alignItems: "center"
  },
  counter: {
    ml: ".2em"
  },
  button: {
    border: "none",
    outline: "none",
    cursor: "pointer",
    background: "transparent",
    appearance: "none",
    position: "relative",
    fontSize: "inherit",
    p: 0,
    "@media (hover: hover)": {
      ":hover": {
        svg: {
          transition: "all 0.2s ease-in-out",
          transform: "scale(1.1)"
        }
      },
      ":active": {
        svg: {
          transition: "all 0.2s ease-in-out",
          transform: "scale(1.1)"
        }
      }
    }
  },
  baloon: {
    opacity: "0",
    position: "absolute",
    transition: "all 0.2s ease-in-out",
    fontSize: ".8em",
    height: "3.4em",
    width: "3.4em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    background: "#292929",
    borderRadius: "100%",
    top: "-3em",
    left: "-1.7em"
  },
  centeredContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }
},
    S = o.keyframes({
  "0%": {
    opacity: "0",
    transform: "translateY(-1em)"
  },
  "72%": {
    opacity: "1",
    transform: "translateY(-4em)"
  },
  "100%": {
    opacity: "0",
    transform: "translateY(-6em)"
  }
}),
    E = o.keyframes({
  "0%": {
    opacity: "0",
    transform: "translateY(-0.5em) scale(1)"
  },
  "32%": {
    opacity: "1",
    transform: "translateY(-1em) scale(1.3)"
  },
  "100%": {
    opacity: "0",
    transform: "translateY(-2em) scale(1.6)"
  }
}),
    z = S,
    M = o.keyframes({
  "0%": {
    transform: "scale(1)"
  },
  "32%": {
    transform: "scale(1.15)"
  },
  "100%": {
    transform: "scale(1.1)"
  }
}),
    A = function A(e) {
  var r = e.id,
      o = e.namespace,
      i = e.hideCounterIfLessThan,
      a = e.children,
      s = e.component,
      c = t.useContext(y),
      l = t.useState(null),
      u = l[0],
      f = l[1];
  x(function () {
    try {
      return Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.clapButtons.info({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]);
  var d = t.useCallback(function (e) {
    try {
      return e.preventDefault(), Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.clapButtons.press({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]),
      p = !0;
  (!u || i && u && u.attributes.total_claps < i) && (p = !1);
  var h = {
    isLoading: !u,
    totalClaps: null == u ? void 0 : u.attributes.total_claps,
    userClaps: null == u ? void 0 : u.attributes.user_claps,
    onClick: d,
    isCounterVisible: p
  };
  return a ? a(h) : n.createElement(s || j, Object.assign({}, h));
};

A.themes = {
  Simple: j,
  Medium: function Medium(e) {
    for (var n = e.isLoading, o = e.userClaps, a = e.totalClaps, s = e.onClick, c = e.isCounterVisible, l = t.useState(!1), u = l[0], f = l[1], m = [], d = 0; d < 5; d++) {
      m.push(r.jsx("div", {
        key: d,
        sx: {
          transform: "rotate(" + 72 * d + "deg)",
          transformOrigin: "0.2em 0",
          marginLeft: "-0.2em"
        }
      }, r.jsx("div", {
        sx: {
          width: "0",
          height: "0",
          opacity: "0",
          borderLeft: "0.2em solid transparent",
          borderRight: "0.2em solid transparent",
          borderTop: "0.2em solid #ff365e",
          position: "absolute",
          animation: u ? E + " 300ms ease forwards" : null
        }
      })));
    }

    for (var p = [], h = 0; h < 5; h++) {
      p.push(r.jsx("div", {
        key: h,
        sx: {
          transform: "rotate(" + 72 * h + "deg)",
          transformOrigin: "0.05em 0",
          marginLeft: "-0.05em"
        }
      }, r.jsx("div", {
        sx: {
          width: "0",
          height: "0",
          opacity: "0",
          padding: "0.05em",
          backgroundColor: "#4086ff",
          borderRadius: "100%",
          position: "absolute",
          animation: u ? E + " 500ms ease forwards" : null
        }
      })));
    }

    var v = t.useRef(null),
        b = t.useCallback(function (e) {
      s(e), f(!0), v.current && clearTimeout(v.current), v.current = setTimeout(function () {
        return f(!1);
      }, 800);
    }, [s]),
        y = o && o > 0 ? L : C;
    return n ? r.jsx("span", null, "Loading...") : r.jsx("div", {
      sx: P.root
    }, r.jsx("button", {
      onClick: b,
      sx: P.button
    }, r.jsx("div", {
      sx: P.centeredContainer
    }, " ", m, " "), r.jsx("div", {
      sx: P.centeredContainer
    }, " ", p, " "), r.jsx("div", {
      sx: P.centeredContainer
    }, r.jsx("div", {
      key: o,
      sx: i({}, P.baloon, {
        animation: u ? z + " 800ms ease forwards" : null
      })
    }, o)), r.jsx(y, {
      sx: {
        height: "3em",
        transition: "all 0.2s ease-in-out",
        animation: u ? M + " 500ms ease forwards" : null
      }
    })), c && r.jsx("div", {
      sx: P.counter
    }, a));
  }
};

var I = function I(e) {
  return n.createElement("svg", {
    fill: "#757575",
    id: "ThumUpWiki",
    viewBox: "0 0 215.34 215.34",
    className: e.className
  }, n.createElement("path", {
    d: "M7.67,93.896h52.077V215.34H7.67V93.896z M207.67,106.682c-7.189-7.189-14.382-14.379-21.572-21.57h-41.451l9.877-25.102  l2.801-7.119l-0.258-2.049L151,2.33L121.115,0L110.15,37.822L80.954,85.176V215.34h107.89L207.67,106.682z"
  }));
},
    B = {
  root: {
    color: "inherit",
    fontFamily: "inherit",
    display: "inline-flex",
    alignItems: "center",
    fontSize: "inherit"
  },
  icon: {
    height: "2em"
  },
  counter: {
    textDecoration: "none",
    backgroundColor: "transparent",
    marginLeft: "1em",
    padding: "0 1em"
  }
},
    _ = {
  colors: {
    primary: "#616161",
    active: "#292929"
  },
  buttons: {
    primary: {
      svg: {
        fill: "primary"
      }
    },
    active: {
      svg: {
        fill: "active"
      }
    }
  }
},
    T = function T(e) {
  var t = e.userLiked,
      n = e.totalLikes,
      o = e.onClick,
      i = e.isCounterVisible;
  return e.isLoading ? r.jsx("span", null, "Loading...") : r.jsx(r.ThemeProvider, {
    theme: _
  }, r.jsx("div", {
    sx: B.root
  }, r.jsx("button", {
    onClick: o,
    sx: {
      boxShadow: "none",
      padding: "1em 1.2em",
      textAlign: "center",
      transitionProperty: "none",
      color: "#616161",
      background: "none",
      border: "none",
      outline: "none",
      cursor: "pointer",
      borderRadius: ".25em",
      variant: t ? "buttons.active" : "buttons.primary",
      bg: "#e0e0e0",
      transition: "all 0.2s ease-in-out",
      "@media (hover: hover)": {
        ":hover": {
          transition: "all 0.2s ease-in-out",
          svg: {
            fill: "#292929"
          }
        }
      }
    }
  }, r.jsx(I, {
    sx: B.icon
  })), i && r.jsx("span", {
    sx: B.counter
  }, n)));
},
    O = function O(e) {
  return n.createElement("svg", {
    viewBox: "0 0 24 24",
    className: e.className
  }, n.createElement("g", null, n.createElement("path", {
    d: "M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12z"
  })));
},
    R = function R(e) {
  return n.createElement("svg", {
    viewBox: "0 0 24 24",
    className: e.className
  }, n.createElement("g", null, n.createElement("path", {
    d: "M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z"
  })));
},
    N = {
  root: {
    color: "inherit",
    fontFamily: "inherit",
    display: "inline-flex",
    alignItems: "center"
  },
  counter: {
    ml: ".2em"
  },
  button: {
    border: "none",
    outline: "none",
    cursor: "pointer",
    background: "transparent",
    appearance: "none",
    position: "relative",
    fontSize: "inherit",
    borderRadius: "100%",
    transition: "all 0.2s ease-in-out",
    width: "3em",
    height: "3em",
    padding: "0",
    lineHeight: "1em",
    "@media (hover: hover)": {
      ":hover": {
        transition: "all 0.2s ease-in-out",
        backgroundColor: "#E5214A20"
      }
    }
  },
  dotsRotContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  dotsContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(165deg)"
  },
  ring: {
    opacity: "0",
    width: "90%",
    height: "90%",
    borderRadius: "3em",
    boxSizing: "border-box",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  icon: {
    height: "2em",
    transition: "all 0.2s ease-in-out",
    fill: "#E5214A",
    display: "block",
    margin: "0 auto",
    animationTimingFunction: "cubic-bezier(0.280, 0.840, 0.420, 1)"
  }
},
    V = o.keyframes({
  "0%": {
    opacity: "0",
    transform: "translateY(-0.5em) scale(1)"
  },
  "52%": {
    opacity: "1",
    transform: "translateY(-1.6em) scale(1.3)"
  },
  "100%": {
    transform: "translateY(-2.7em) scale(0)"
  }
}),
    D = o.keyframes({
  "0%": {
    transform: "scale(0)"
  },
  "52%": {
    transform: "scale(1.2)"
  },
  "72%": {
    transform: "scale(0.9)"
  },
  "100%": {
    transform: "scale(1)"
  }
}),
    U = ["lightcoral", "yellow", "pink", "lightseagreen", "orange", "aliceblue"],
    F = o.keyframes({
  "0%": {
    opacity: "1",
    borderWidth: "0.5em"
  },
  "52%": {
    opacity: "0",
    borderWidth: "0"
  }
}),
    K = D,
    G = function G(e) {
  var r = e.id,
      o = e.namespace,
      i = e.hideCounterIfLessThan,
      a = e.children,
      s = e.component,
      c = t.useContext(y),
      l = t.useState(null),
      u = l[0],
      f = l[1];
  x(function () {
    try {
      return Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.likeButtons.info({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]);
  var d = t.useCallback(function (e) {
    try {
      return e.preventDefault(), Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.likeButtons.press({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]),
      p = !0;
  (!u || i && u && u.attributes.total_likes < i) && (p = !1);
  var h = {
    isLoading: !u,
    totalLikes: null == u ? void 0 : u.attributes.total_likes,
    userLiked: null == u ? void 0 : u.attributes.user_has_liked,
    onClick: d,
    isCounterVisible: p
  };
  return a ? a(h) : n.createElement(s || T, Object.assign({}, h));
};

G.themes = {
  Simple: T,
  Twitter: function Twitter(e) {
    for (var n = e.isLoading, o = e.userLiked, a = e.totalLikes, s = e.onClick, c = e.isCounterVisible, l = t.useState(!1), u = l[0], f = l[1], m = [], d = 0; d < 6; d++) {
      m.push(r.jsx("div", {
        key: d,
        sx: {
          transform: "rotate(" + 60 * d + "deg)",
          transformOrigin: "0.2em 0",
          marginLeft: "-0.2em"
        }
      }, r.jsx("div", {
        sx: {
          opacity: "0",
          width: "0.2em",
          height: "0.2em",
          borderRadius: "0.2em",
          backgroundColor: "" + U[d],
          position: "absolute",
          animation: u ? V + " 600ms ease forwards" : null
        }
      })));
    }

    var p = r.jsx("div", {
      sx: i({}, N.ring, {
        border: "1px solid #e095ed",
        animation: u ? F + " 600ms ease forwards" : null
      })
    }),
        h = t.useCallback(function (e) {
      o || (f(!0), setTimeout(function () {
        return f(!1);
      }, 600)), s(e);
    }, [o, s]),
        v = o ? O : R;
    return n ? r.jsx("span", null, "Loading...") : r.jsx("div", {
      sx: N.root
    }, r.jsx("button", {
      onClick: h,
      sx: N.button
    }, r.jsx("div", {
      sx: N.dotsContainer
    }, " ", m, " "), r.jsx("div", {
      sx: N.dotsRotContainer
    }, " ", m, " "), p, r.jsx(v, {
      sx: i({}, N.icon, {
        animation: u ? K + " 700ms ease forwards" : null
      })
    })), c && r.jsx("div", {
      sx: N.counter
    }, a));
  }
};

var W = function W(e) {
  return n.createElement("svg", {
    fill: "#757575",
    id: "ThumUpWiki",
    viewBox: "0 0 215.34 215.34",
    className: e.className
  }, n.createElement("path", {
    d: "M7.67,93.896h52.077V215.34H7.67V93.896z M207.67,106.682c-7.189-7.189-14.382-14.379-21.572-21.57h-41.451l9.877-25.102  l2.801-7.119l-0.258-2.049L151,2.33L121.115,0L110.15,37.822L80.954,85.176V215.34h107.89L207.67,106.682z"
  }));
},
    q = {
  root: {
    color: "inherit",
    fontFamily: "inherit",
    display: "inline-flex",
    alignItems: "center"
  },
  counter: {
    ml: ".5em",
    mr: ".5em",
    minWidth: "2em",
    textAlign: "center"
  },
  icon: {
    height: "1em",
    transition: "all 0.2s ease-in-out",
    display: "block",
    margin: "0 auto",
    animationTimingFunction: "cubic-bezier(0.280, 0.840, 0.420, 1)",
    fill: "#292929"
  },
  ring: {
    opacity: "0",
    width: "90%",
    height: "90%",
    borderRadius: "3em",
    border: "1px solid #e095ed",
    boxSizing: "border-box",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  button: {
    border: "none",
    outline: "none",
    cursor: "pointer",
    background: "transparent",
    appearance: "none",
    position: "relative",
    fontSize: "inherit",
    borderRadius: "100%",
    transition: "all 0.2s ease-in-out",
    width: "3em",
    height: "3em",
    padding: "0",
    lineHeight: "1em"
  }
},
    Y = {
  colors: {
    lightGray: "#e0e0e0",
    darkGray: "#292929",
    darkBlue: "#22c1c3",
    lightBlue: "#21fdd530",
    darkPink: "#ff00c3",
    lightPink: "#ff00c310"
  },
  buttons: {
    downInactive: {
      backgroundColor: "lightGray",
      svg: {
        fill: "darkGray"
      }
    },
    upInactive: {
      backgroundColor: "lightGray",
      svg: {
        fill: "darkGray"
      }
    },
    upActive: {
      backgroundColor: "lightBlue",
      svg: {
        fill: "darkBlue"
      }
    },
    downActive: {
      backgroundColor: "lightPink",
      svg: {
        fill: "darkPink"
      }
    }
  }
},
    H = o.keyframes({
  "0%": {
    transform: "scale(0)"
  },
  "52%": {
    transform: "scale(1.2)"
  },
  "72%": {
    transform: "scale(0.9)"
  },
  "100%": {
    transform: "scale(1)"
  }
}),
    J = o.keyframes({
  "0%": {
    opacity: "1",
    borderWidth: "0.5em"
  },
  "52%": {
    opacity: "0",
    borderWidth: "0"
  }
}),
    Q = H,
    X = function X(e) {
  var n = e.isLoading,
      o = e.userVoteDirection,
      a = e.totalScore,
      s = e.onPressUp,
      c = e.onPressDown,
      l = e.isCounterVisible,
      u = t.useState(!1),
      f = u[0],
      m = u[1],
      d = t.useState(!1),
      p = d[0],
      h = d[1],
      v = t.useCallback(function (e) {
    s(e), 1 !== o && (m(!0), setTimeout(function () {
      return m(!1);
    }, 700));
  }, [o, s]),
      b = t.useCallback(function (e) {
    c(e), -1 !== o && (h(!0), setTimeout(function () {
      return h(!1);
    }, 700));
  }, [o, c]);
  if (n) return r.jsx("span", null, "Loading...");
  var y = i({}, q.icon, {
    animation: f ? Q + " 700ms ease forwards" : null
  }),
      g = i({}, q.icon, {
    animation: p ? Q + " 700ms ease forwards" : null
  }),
      x = i({}, q.ring, {
    animation: f ? J + " 600ms ease forwards" : null
  }),
      k = i({}, q.ring, {
    animation: p ? J + " 600ms ease forwards" : null
  });
  return r.jsx(r.ThemeProvider, {
    theme: Y
  }, r.jsx("div", {
    sx: q.root
  }, r.jsx("button", {
    onClick: v,
    sx: i({}, q.button, {
      variant: 1 === o ? "buttons.upActive" : "buttons.upInactive",
      "@media (hover: hover)": {
        ":hover": {
          variant: "buttons.upActive",
          transition: "all 0.2s ease-in-out"
        }
      }
    })
  }, r.jsx("div", {
    sx: x
  }), r.jsx(W, {
    sx: y
  })), l && r.jsx("div", {
    sx: q.counter
  }, a), r.jsx("button", {
    onClick: b,
    sx: i({}, q.button, {
      transform: "rotate(180deg)",
      variant: -1 === o ? "buttons.downActive" : "buttons.downInactive",
      "@media (hover: hover)": {
        ":hover": {
          variant: "buttons.downActive",
          transition: "all 0.2s ease-in-out"
        }
      }
    })
  }, r.jsx("div", {
    sx: k
  }), r.jsx(W, {
    sx: g
  }))));
},
    Z = function Z(e) {
  return n.createElement("svg", {
    version: "1.0",
    viewBox: "0 0 1280 1280",
    className: e.className,
    preserveAspectRatio: "xMidYMid meet"
  }, n.createElement("g", {
    transform: "translate(0,1280) scale(0.100000,-0.100000)",
    stroke: "none"
  }, n.createElement("path", {
    d: "M6245 12778 c-200 -44 -333 -117 -494 -272 -53 -51 -1149 -1102\n  -2436 -2336 -3028 -2904 -3071 -2945 -3122 -3010 -133 -170 -219 -465 -183\n  -629 35 -159 45 -192 80 -267 50 -109 104 -185 187 -265 83 -81 140 -119 246\n  -169 175 -81 33 -74 1677 -77 1359 -3 1466 -4 1478 -20 9 -13 12 -527 12\n  -2487 0 -2658 -2 -2524 50 -2663 84 -226 259 -410 479 -503 40 -17 123 -42\n  184 -56 l112 -24 1905 3 c1897 2 1905 2 1995 23 173 41 319 120 439 238 104\n  102 171 212 222 366 l29 85 5 2507 c3 1701 8 2510 15 2517 7 7 487 12 1475 13\n  1644 4 1502 -3 1677 78 104 48 161 88 247 169 137 131 213 277 256 491 25 119\n  25 151 0 270 -32 159 -75 262 -155 375 -53 75 -26 49 -3010 2910 -1353 1297\n  -2506 2402 -2561 2456 -169 163 -299 234 -509 278 -119 25 -181 25 -300 -1z"
  })));
},
    $ = {
  root: {
    color: "inherit",
    fontFamily: "inherit",
    display: "inline-flex",
    alignItems: "center",
    flexDirection: "column"
  },
  counter: {
    mt: ".2em",
    mb: ".2em",
    minWidth: "2em",
    textAlign: "center"
  },
  icon: {
    height: "1em",
    transition: "all 0.2s ease-in-out",
    display: "block",
    margin: "0 auto",
    animationTimingFunction: "cubic-bezier(0.280, 0.840, 0.420, 1)"
  },
  button: {
    border: "none",
    outline: "none",
    cursor: "pointer",
    background: "transparent",
    appearance: "none",
    position: "relative",
    fontSize: "inherit",
    borderRadius: "3px",
    transition: "all 0.2s ease-in-out",
    width: "2em",
    height: "2em",
    padding: "0",
    lineHeight: "1em"
  }
},
    ee = {
  colors: {
    lightGray: "#25252510",
    darkGray: "#878a8c",
    blue: "#5a75cc",
    red: "#cc3700"
  },
  buttons: {
    downInactive: {
      svg: {
        fill: "darkGray"
      }
    },
    upInactive: {
      svg: {
        fill: "darkGray"
      }
    },
    upActive: {
      backgroundColor: "lightGray",
      svg: {
        fill: "red"
      }
    },
    downActive: {
      backgroundColor: "lightGray",
      svg: {
        fill: "blue"
      }
    }
  }
},
    te = o.keyframes({
  "0%": {
    transform: "scale(0)"
  },
  "52%": {
    transform: "scale(1.2)"
  },
  "72%": {
    transform: "scale(0.9)"
  },
  "100%": {
    transform: "scale(1)"
  }
}),
    ne = function ne(e) {
  var r = e.id,
      o = e.namespace,
      i = e.hideCounterIfLessThan,
      a = e.children,
      s = e.component,
      c = t.useContext(y),
      l = t.useState(null),
      u = l[0],
      f = l[1];
  x(function () {
    try {
      return Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.updownButtons.info({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]);
  var d = t.useCallback(function (e) {
    try {
      return e.preventDefault(), Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.updownButtons.pressUp({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]),
      p = t.useCallback(function (e) {
    try {
      return e.preventDefault(), Promise.resolve(m(function () {
        var e = function () {
          if (c) return Promise.resolve(c.updownButtons.pressDown({
            id: r,
            namespace: o
          })).then(function (e) {
            f(e.data);
          });
        }();

        if (e && e.then) return e.then(function () {});
      }, function (e) {
        throw console.error("Lyket error:", e), e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [c, r, o]),
      h = !0;
  (!u || i && u && u.attributes.total_score < i) && (h = !1);
  var v = {
    isLoading: !u,
    totalScore: null == u ? void 0 : u.attributes.total_score,
    userVoteDirection: null == u ? void 0 : u.attributes.user_vote_direction,
    onPressUp: d,
    onPressDown: p,
    isCounterVisible: h
  };
  return a ? a(v) : n.createElement(s || X, Object.assign({}, v));
};

ne.themes = {
  Simple: X,
  Reddit: function Reddit(e) {
    var n = e.isLoading,
        o = e.userVoteDirection,
        a = e.totalScore,
        s = e.onPressUp,
        c = e.onPressDown,
        l = e.isCounterVisible,
        u = t.useState(!1),
        f = u[0],
        m = u[1],
        d = t.useState(!1),
        p = d[0],
        h = d[1],
        v = t.useCallback(function (e) {
      s(e), 1 !== o && (m(!0), setTimeout(function () {
        return m(!1);
      }, 700));
    }, [o, s]),
        b = t.useCallback(function (e) {
      c(e), -1 !== o && (h(!0), setTimeout(function () {
        return h(!1);
      }, 700));
    }, [o, c]);
    if (n) return r.jsx("span", null, "Loading...");
    var y = i({}, $.icon, {
      animation: f ? te + " 700ms ease forwards" : null
    }),
        g = i({}, $.icon, {
      animation: p ? te + " 700ms ease forwards" : null
    });
    return r.jsx(r.ThemeProvider, {
      theme: ee
    }, r.jsx("div", {
      sx: $.root
    }, r.jsx("button", {
      onClick: v,
      sx: i({}, $.button, {
        variant: 1 === o ? "buttons.upActive" : "buttons.upInactive",
        "@media (hover: hover)": {
          ":hover": {
            variant: "buttons.upActive",
            transition: "all 0.2s ease-in-out"
          }
        }
      })
    }, r.jsx(Z, {
      sx: y
    })), l && r.jsx("div", {
      sx: $.counter
    }, a), r.jsx("button", {
      onClick: b,
      sx: i({}, $.button, {
        transform: "rotate(180deg)",
        variant: -1 === o ? "buttons.downActive" : "buttons.downInactive",
        "@media (hover: hover)": {
          ":hover": {
            variant: "buttons.downActive",
            transition: "all 0.2s ease-in-out"
          }
        }
      })
    }, r.jsx(Z, {
      sx: g
    }))));
  }
}, exports.ClapButton = A, exports.Client = b, exports.LikeButton = G, exports.Provider = function (e) {
  var n = e.apiKey,
      o = e.recaptchaSiteKey,
      a = e.baseUrl,
      s = e.children,
      c = t.useState(new b({
    apiKey: n,
    baseUrl: a,
    recaptchaSiteKey: o
  })),
      l = c[0],
      u = c[1];
  return t.useEffect(function () {
    u(new b({
      apiKey: n,
      baseUrl: a,
      recaptchaSiteKey: o
    }));
  }, [n, o, a]), r.jsx(r.ThemeProvider, {
    theme: i({}, g, {
      styles: {},
      useBodyStyles: !1,
      useLocalStorage: !1
    })
  }, r.jsx(y.Provider, {
    value: l
  }, s));
}, exports.UpdownButton = ne;